import { Component, inject, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { GlobalService } from '../../services/global.service';
import { CommonModule, JsonPipe } from '@angular/common';
import { AgGridListComponent } from '../../components/ag-grid-list/ag-grid-list.component';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { ButtonComponent } from '../../components/button/button.component';
import { HeaderComponent } from '../../components/header/header.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { DropdownService } from '../../services/dropdown.service';
import { BarcodeService } from '../../services/barcode.service';
import { ValidationService } from '../../services/validation.service';
import { FormService } from '../../services/form.service';
import { StudentMappingService } from '../../services/student-mapping.service';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-student-mapping-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, FormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, SelectInputComponent, JsonPipe, DropdownUploadButtonComponent],
  templateUrl: './student-mapping-list-page.component.html',
  styleUrl: './student-mapping-list-page.component.css'
})
export class StudentMappingListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any

  page_name = 'Student Mapping';
  form: FormGroup;
  params: any = {};
  selected_item: any = {}
  items: any = [];
  fs = inject(FormService);
  show_menu = false;

  columns: any = [
    { field: 'User.registration_number', headerName: 'Unique ID', filter: true, flex: 1 },
    { headerName: 'Roll No', filter: true, flex: 1, valueGetter: (data: any) => { return data.data?.roll_number || data.data?.User?.roll_number || '-'; } },
    {
      headerName: 'Subject', filter: true, flex: 2, autoHeight: true,
      cellRenderer: (params: any) => {
        const subjects = params.data?.Subjects;
        if (!subjects || !Array.isArray(subjects) || subjects.length === 0) return '<span style="color:#9ca3af">—</span>';
        const chips = subjects.map((s: any) =>
          `<span style="display:inline-flex;align-items:center;gap:8px;background:#ede9fe;color:#4338ca;padding:6px 14px;border-radius:10px;font-size:13px;font-weight:500;white-space:nowrap;line-height:1;">${s?.name}&nbsp;<span style="font-size:11px;opacity:0.7;">✕</span></span>`
        ).join('');
        return `<div style="display:flex;flex-wrap:wrap;gap:8px;align-items:center;padding:10px 0;">${chips}</div>`;
      }
    },
    // { field: 'Exam.name', headerName: 'Exam', filter: true, flex: 1 },
    { headerName: "Actions", sortable: false, filter: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 210, minWidth: 210, maxWidth: 210 }
  ];

  bulk_columns = [
    { column_name: 'Unique ID', type: 'link', linked_list: 'student_name_list', returning_key: 'id', return_as: 'student_id', sample_value: 'REG2021001' },
    { column_name: 'Student Roll No', type: 'text', return_as: 'roll_number', regex: this.vs.roll_number_pattern, regex_error: 'Invalid Roll No. Only alphanumeric characters, hyphens (-) and slashes (/) are allowed.', sample_value: '2021001' },
  ];

  bulk_columns_download = [
    { column_name: 'Exam', download_bind: 'exam_id', type: 'link', linked_list: 'exam_list', linked_from: 'exam', return_as: 'exam_id', sample_value: 'AD' },
    { column_name: 'Subject', download_bind: 'subject_id', type: 'link', linked_list: 'subject_list', linked_from: 'subject', return_as: 'subject_id', sample_value: 'AD' },
    { column_name: 'Roll No', download_bind: 'student_id', type: 'link', linked_list: 'student_list', linked_from: 'student', return_as: 'student_id', sample_value: 'AD' },
    { column_name: 'Barcode', type: 'text', return_as: 'barcode', sample_value: '111' },
  ]

  actions(row: any) {
    let actions: any = []
    // actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this) })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.script_management_barcode_mapping_view })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.script_management_barcode_mapping_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this), permissions: this.gs.user_role_data?.script_management_barcode_mapping_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public sms: StudentMappingService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      university_id: ['', [Validators.required]],
      academic_year_id: ['', [Validators.required]],
      exam_id: ['', [Validators.required]],
      subject_ids: [, [Validators.required]],
      student_id: ['', [Validators.required]],
      roll_number: ['', [Validators.required, Validators.pattern(this.vs.roll_number_pattern), Validators.maxLength(this.vs.max_length_description)]],
      is_active: [true]
    });
  }

  async ngOnInit() {
    await this.ds?.get_dropdown_list(['academic-year', 'university', 'exam', 'subject', 'student', 'student_data', 'assessment']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      // await this.get_list(this.params);
    })

  }
  async get_list(filter?: any) {
    try {
      const merged: any = { ...filter };
      if (this.filter_university_id) merged.university_id = this.filter_university_id;
      if (this.filter_academic_year_id) merged.academic_year_id = this.filter_academic_year_id;
      if (this.filter_exam_id) merged.exam_id = this.filter_exam_id;
      const res = await this.sms.get_list(merged);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async delete(item: any, index: any) {
    this.selected_item = item;
    this.confirmation_delete_modal?.open();
  }
  async open_disable_modal(item: any, index: any) {
    this.selected_item = item;
    this.confirmation_disabled_modal?.open();
  }
  async disable() {
    try {
      let res = await this.sms.delete(this.selected_item.id);
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      this.selected_item = {};
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    try {
      let res: any
      for (let id of ids) {
        res = await this.sms.delete(id);
      }
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async open_form_modal(item?: any) {
    this.selected_item = item || {};
    if (this.selected_item && this.selected_item.id) {
      let response = await this.sms.get(item.id);
      this.selected_item = { ...response.data };
      this.form.patchValue({
        ...this.selected_item,
        university_id: this.selected_item.university_id || this.selected_item.University?.id,
        academic_year_id: this.selected_item.academic_year_id || this.selected_item.AcademicYear?.id,
        exam_id: this.selected_item.exam_id || this.selected_item.Exam?.id,
        student_id: this.selected_item.student_id || this.selected_item.User?.id,
      });
      this.filtered_exams_for_form = this.get_exams_for_filters(
        this.selected_item.university_id || this.selected_item.University?.id,
        this.selected_item.academic_year_id || this.selected_item.AcademicYear?.id
      );
      this.update_subjects_for_exam();
      this.update_students_for_university();
      setTimeout(() => {
        this.form.patchValue({
          subject_ids: this.selected_item.subject_ids || this.selected_item.Subjects?.map((s: any) => s.id),
        });
      });
    } else {
      this.selected_item = {};
      this.form.reset();
      this.filtered_subjects_for_exam = [];
      this.filtered_exams_for_form = [];
      this.filtered_students_for_form = [];
    }
    this.form_modal?.open();
  }
  async open_view_modal(item: any) {
    this.selected_item = item || {};
    try {
      const response = await this.sms.get(item.id);
      this.selected_item = response.data;
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
    this.view_modal?.open();
  }

  filter_university_id: any = '';
  filter_academic_year_id: any = '';
  filter_exam_id: any = '';
  filtered_exams_for_list: any[] = [];

  filtered_subjects_for_exam: any[] = [];
  filtered_exams_for_form: any[] = [];
  filtered_students_for_form: any[] = [];

  bulk_form: FormGroup = this.fb.group({
    university_id: ['', Validators.required],
    academic_year_id: ['', Validators.required],
    exam_id: ['', Validators.required],
    subject_ids: [[], Validators.required],
  });
  bulk_filtered_subjects: any[] = [];
  bulk_filtered_exams: any[] = [];

  get bulk_extra_data() {
    return this.bulk_form.value;
  }

  onBulkUniversityOrYearChange() {
    this.bulk_form.patchValue({ exam_id: '', subject_ids: [] });
    this.bulk_filtered_subjects = [];
    this.bulk_filtered_exams = this.get_exams_for_filters(this.bulk_form.value.university_id, this.bulk_form.value.academic_year_id);
  }

  onBulkExamChange() {
    this.bulk_form.patchValue({ subject_ids: [] });
    this.bulk_filtered_subjects = this.get_subjects_for_exam(this.bulk_form.value.exam_id, this.bulk_form.value.university_id, this.bulk_form.value.academic_year_id);
  }

  get_exams_for_filters(university_id: any, academic_year_id: any): any[] {
    if (!this.ds.dropdown_list?.assessment_list) return [];
    const seen = new Set();
    return this.ds.dropdown_list.assessment_list
      .filter((a: any) =>
        (!university_id || a.university_id == university_id) &&
        (!academic_year_id || a.academic_year_id == academic_year_id)
      )
      .reduce((acc: any[], a: any) => {
        const eid = a.exam_id || a.exam?.id;
        const name = a.exam?.name || a.exam?.title;
        if (eid && !seen.has(eid)) { seen.add(eid); acc.push({ title: name, value: eid }); }
        return acc;
      }, []);
  }

  get_subjects_for_exam(exam_id: any, university_id?: any, academic_year_id?: any): any[] {
    if (!exam_id || !this.ds.dropdown_list?.assessment_list) return [];
    const seen = new Set();
    return this.ds.dropdown_list.assessment_list
      .filter((a: any) =>
        a.exam_id == exam_id &&
        (!university_id || a.university_id == university_id) &&
        (!academic_year_id || a.academic_year_id == academic_year_id)
      )
      .reduce((acc: any[], a: any) => {
        const sid = a.subject?.id || a.subject_id;
        const name = a.subject?.name || a.subject?.title;
        if (sid && !seen.has(sid)) { seen.add(sid); acc.push({ title: name, value: sid }); }
        return acc;
      }, []);
  }

  update_subjects_for_exam() {
    this.filtered_subjects_for_exam = this.get_subjects_for_exam(
      this.form.get('exam_id')?.value,
      this.form.get('university_id')?.value,
      this.form.get('academic_year_id')?.value
    );
  }

  on_list_university_or_year_change() {
    this.filter_exam_id = '';
    this.filtered_exams_for_list = this.get_exams_for_filters(this.filter_university_id, this.filter_academic_year_id);
    this.on_list_filter_change();
  }

  on_list_exam_change() {
    this.on_list_filter_change();
  }

  on_list_filter_change() {
    const filter: any = { ...this.params };
    if (this.filter_university_id) filter.university_id = this.filter_university_id;
    if (this.filter_academic_year_id) filter.academic_year_id = this.filter_academic_year_id;
    if (this.filter_exam_id) filter.exam_id = this.filter_exam_id;
    this.get_list(filter);
  }

  onFormUniversityOrYearChange() {
    this.form.patchValue({ exam_id: '', subject_ids: null, student_id: '' });
    this.filtered_subjects_for_exam = [];
    this.filtered_exams_for_form = this.get_exams_for_filters(this.form.get('university_id')?.value, this.form.get('academic_year_id')?.value);
    this.update_students_for_university();
  }

  update_students_for_university() {
    const university_id = this.form.get('university_id')?.value;
    const all = this.ds.dropdown_list?.student_name_list || [];
    this.filtered_students_for_form = university_id
      ? all.filter((s: any) => s.university_id == university_id)
      : all;
  }

  onFormExamChange() {
    this.form.get('subject_ids')?.reset();
    this.update_subjects_for_exam();
  }

  get_subject_names(): string {
    const subjects = this.selected_item?.Subjects;
    if (!subjects?.length) return '—';
    return subjects.map((s: any) => s?.name).join(', ');
  }

  get_mapped_barcodes(): string {
    const mappings = this.selected_item?.BarcodeMappings;
    const subjectIds: any[] = this.selected_item?.Subjects?.map((s: any) => s.id) || this.selected_item?.subject_ids || [];
    if (!mappings?.length) return '—';
    const filtered = mappings.filter((m: any) => subjectIds.some((id: any) => id == m.subject_id));
    return filtered.length ? filtered.map((m: any) => m.barcode).join(', ') : '—';
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.sms.update(this.selected_item.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async submit() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let form_value = this.form.value;
      form_value.is_active = true;
      if (this.selected_item && this.selected_item.id) {
        let update_response = await this.sms.update(this.selected_item.id, form_value);
        this.gs.toastr_shows_function('Student Mapping Updated Successfully', 'Success', 'success');
      } else {
        let create_response = await this.sms.add(form_value);
        this.gs.toastr_shows_function('Student Mapped Successfully', 'Success', 'success');
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        subject_ids: Array.isArray(item.subject_ids) ? item.subject_ids : (item.subject_ids != null ? [item.subject_ids] : []),
        is_active: true
      }));
      console.log(updatedData, 'dataa');

      await this.gs.bulk_form_submission(updatedData, this.sms, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
}
